<template>
  <div>
    <v-alert :color="color" :icon="icon" dense text outlined class="mb-2">
      <v-row>
        <v-col :cols="isMobile ? 12 : undefined" :class="{'white--text': dark}">
          <div class="truncated-text">{{note.noteType}} Note: <span v-html="note.content.replace(/\n/g, '<br>')"></span></div>
        </v-col>
        <v-col :cols="isMobile ? undefined : 'auto'">
          <v-btn
            :color="dark ? 'white' : color"
            outlined
            small
            :block="isMobile"
            @click="$emit('seeMore', linkAnchor)">
            See More
          </v-btn>
        </v-col>
        <v-col cols="auto" v-if="!hidePin">
          <EsButtonIcon
            :icon="note.isPinned ? 'mdi-pin' : 'mdi-pin-outline'"
            small
            :color="dark ? 'white' : note.isPinned ? color : pinColor"
            aria-label="pin note"
            @click="confirmPin()" />
        </v-col>
      </v-row>
    </v-alert>
    <v-dialog v-if="showDialog" v-model="showDialog" width="500">
      <v-card>
        <v-card-text class="pt-5">
          Unpinning this note will cause it to be unpinned from all requests. Are you sure you want to unpin this note?
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col>
              <EsButtonCancel block @click="showDialog = false" />
            </v-col>
            <v-col>
              <EsButtonSave
                block
                label="Yes, Unpin"
                @click="unpinNote()" />
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { EsButtonIcon, EsButtonCancel, EsButtonSave } from "@86-repairs/design-system";

export default {
  name: 'EsNoteDisplay',
  props: {
    note: {
      type: Object,
      required: true,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    hidePin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EsButtonIcon,
    EsButtonCancel,
    EsButtonSave,
  },
  data: () => ({
    color: 'grey',
    icon: 'mdi-info',
    pinColor: 'grey',
    linkAnchor: '',
    showDialog: false,
  }),
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.setNoteType();
  },
  methods: {
    setNoteType() {
      let color;
      let icon;
      let pinColor;
      let linkAnchor;
      switch (this.note.noteType) {
        case 'Asset':
          color = 'brown';
          icon = 'mdi-stove';
          pinColor = 'brown lighten-3';
          linkAnchor = 'asset';
          break;
        case 'Customer':
          color = 'pink darken-1';
          icon = 'mdi-storefront';
          pinColor = 'pink lighten-3';
          linkAnchor = 'customer';
          break;
        case 'Customer Vendor':
          color = 'pink darken-1';
          icon = 'mdi-storefront';
          pinColor = 'pink lighten-3';
          linkAnchor = 'customerVendor';
          break;
        case 'Location':
          color = 'amber darken-4';
          icon = 'mdi-storefront';
          pinColor = 'deep-orange lighten-3';
          linkAnchor = 'location';
          break;
        case 'Location Vendor':
          color = 'amber darken-4';
          icon = 'mdi-storefront';
          pinColor = 'deep-orange lighten-3';
          linkAnchor = 'locationVendor';
          break;
        case 'Vendor':
          color = 'blue darken-2';
          icon = 'mdi-wrench';
          pinColor = 'blue lighten-3';
          linkAnchor = 'vendor';
          break;
        case 'PM Quote':
          color = 'deep-purple';
          icon = 'mdi-alpha-p-circle-outline';
          pinColor = 'deep-purple lighten-3';
          linkAnchor = 'pmQuote';
          break;
        default:
          color = 'grey darken-1';
          icon = 'mdi-information';
          pinColor = 'grey';
          linkAnchor = '';
      }
      this.color = color;
      this.icon = icon;
      this.pinColor = pinColor;
      this.linkAnchor = linkAnchor;
    },
    confirmPin() {
      if (this.note.isPinned) {
        this.showDialog = true;
      } else {
        this.$emit("pinNote", {
          noteToPin: this.note.id,
          noteToUnpin: undefined,
        });      
      }
    },
    unpinNote() {
      this.$emit("pinNote", {
        noteToPin: undefined,
        noteToUnpin: this.note.id,
      });
      this.showDialog = false;
    }
  }
}
</script>

<style scoped>
.truncated-text {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical; 
}
</style>